import type { SVGProps } from "react";
export default function SvgMemoDraftingAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 112 112"
			{...props}
		>
			<path
				fill="#FAFF00"
				d="M64.007 14.138H52.614c0-3.389-2.76-6.138-6.162-6.138s-6.162 2.75-6.162 6.138H28.897a3.677 3.677 0 0 0-3.684 3.67v7.458c0 2.027 1.65 3.67 3.684 3.67h35.11a3.677 3.677 0 0 0 3.684-3.67v-7.458c0-2.027-1.65-3.67-3.684-3.67"
			/>
			<foreignObject width={98.4385} height={120.663} x={-2.74658} y={1.33691}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1110_617_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_i_1110_617)">
				<path
					fill="url(#paint0_linear_1110_617)"
					fillOpacity={0.6}
					d="M72.375 19.337H20.57c-2.936 0-5.317 2.37-5.317 5.296v74.072c0 2.924 2.38 5.295 5.317 5.295h51.805c2.936 0 5.317-2.371 5.317-5.295V24.633c0-2.925-2.38-5.296-5.317-5.296"
				/>
				<path
					stroke="url(#paint1_linear_1110_617)"
					d="M20.57 19.837h51.806c2.661 0 4.816 2.15 4.816 4.796v74.071c0 2.647-2.155 4.796-4.816 4.796H20.57c-2.662 0-4.817-2.149-4.817-4.796V24.633c0-2.647 2.155-4.796 4.817-4.796Z"
				/>
			</g>
			<foreignObject width={82.0684} height={81.8936} x={32.6777} y={34.04}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1110_617_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_i_1110_617)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="m60.012 95.015-7.29 2.814c-1.214.47-2.409-.723-1.94-1.932l2.824-7.262a9 9 0 0 1 2.027-3.1l32.748-32.62a3.003 3.003 0 0 1 4.24 0l3.248 3.237a2.98 2.98 0 0 1 0 4.222l-32.748 32.62a9 9 0 0 1-3.112 2.019z"
				/>
				<path
					stroke="url(#paint2_linear_1110_617)"
					strokeOpacity={0.5}
					d="M88.734 53.27a2.504 2.504 0 0 1 3.344-.171l.19.17 3.249 3.237a2.48 2.48 0 0 1 0 3.514l-32.75 32.62a8.5 8.5 0 0 1-2.938 1.906l-.719.277.003.003-6.571 2.536h-.001c-.811.314-1.603-.483-1.293-1.284l2.824-7.262a8.5 8.5 0 0 1 1.913-2.926z"
				/>
			</g>
			<path
				fill="#F5FCFF"
				d="M64.32 46.052H28.586a2.253 2.253 0 0 1-2.258-2.25 2.253 2.253 0 0 1 2.258-2.248H64.32a2.253 2.253 0 0 1 2.258 2.249 2.253 2.253 0 0 1-2.258 2.249"
			/>
			<path
				fill="#F5FCFF"
				d="M64.32 60.077H28.586a2.253 2.253 0 0 1-2.258-2.249 2.253 2.253 0 0 1 2.258-2.249H64.32a2.253 2.253 0 0 1 2.258 2.25 2.253 2.253 0 0 1-2.258 2.248"
			/>
			<path
				fill="#F5FCFF"
				d="M47.332 74.104H28.586a2.253 2.253 0 0 1-2.258-2.249 2.253 2.253 0 0 1 2.258-2.249h18.746a2.253 2.253 0 0 1 2.258 2.25 2.253 2.253 0 0 1-2.258 2.248"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1110_617"
					x1={46.6318}
					x2={46.6318}
					y1={19.3369}
					y2={104}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_617"
					x1={46.4726}
					x2={9.33008}
					y1={20.2641}
					y2={81.1377}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_617"
					x1={73.712}
					x2={73.712}
					y1={52.04}
					y2={97.9334}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1110_617_clip_path" transform="translate(2.747 -1.337)">
					<path d="M72.375 19.337H20.57c-2.936 0-5.317 2.37-5.317 5.296v74.072c0 2.924 2.38 5.295 5.317 5.295h51.805c2.936 0 5.317-2.371 5.317-5.295V24.633c0-2.925-2.38-5.296-5.317-5.296" />
				</clipPath>
				<clipPath id="bgblur_1_1110_617_clip_path" transform="translate(-32.678 -34.04)">
					<path d="m60.012 95.015-7.29 2.814c-1.214.47-2.409-.723-1.94-1.932l2.824-7.262a9 9 0 0 1 2.027-3.1l32.748-32.62a3.003 3.003 0 0 1 4.24 0l3.248 3.237a2.98 2.98 0 0 1 0 4.222l-32.748 32.62a9 9 0 0 1-3.112 2.019z" />
				</clipPath>
				<filter
					id="filter0_i_1110_617"
					width={98.4385}
					height={120.663}
					x={-2.74658}
					y={1.33691}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_617" />
				</filter>
				<filter
					id="filter1_i_1110_617"
					width={82.0684}
					height={81.8936}
					x={32.6777}
					y={34.04}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_617" />
				</filter>
			</defs>
		</svg>
	);
}
